<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add v-if="hasPerm('fe_invoices.create')" @invoke-method="invokeMethod($event)" action="openFeInvoiceForm"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetFeInvoices(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile class="mb-3">
                                        <bc-autocomplete
                                            v-model="filter.status_id"
                                            :placeholder="$t('lang.status_id')"
                                            :items="fe_invoice_status"
                                            item-value="option_id"
                                            item-text="option"
                                            prepend-icon="monitor_heart"
                                            :hide-details="true"
                                            clearable
                                            @click:clear="filterClearInput()"
                                        ></bc-autocomplete>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="fe_invoices" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openFeInvoiceForm(props.item)">
                                <td>{{ props.item.invoice_id }}</td>
                                <td>{{ props.item.company }}</td>
                                <td class="text-center">{{ props.item.invoice_date }}</td>
                                <td class="text-center">{{ props.item.due_date }}</td>
                                <td>{{ props.item.total_amount }}</td>
                                <td>{{ props.item.balance }}</td>
                                <td class="text-center">
                                    <v-chip disabled round text-color="white" class="fs-14 text-center" :color="props.item.status_class">
                                        <span style="min-width: 60px">{{ props.item.status }}</span>
                                    </v-chip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="fe_invoices"></bc-pagination>
                </v-card-text>
            </v-card>
            <delete-confirmation-dialog
                ref="delete_fe_invoices"
                :heading="$t('lang.delete_fe_invoice')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteFeInvoices(fe_invoice.invoice_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openFeInvoiceForm" },
                { title: this.$t("lang.refresh"), action: "dbGetFeInvoices", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.invoice_id"), sortable: false, width: "10%" },
                { text: this.$t("lang.company_id"), sortable: false, width: "25%" },
                { text: this.$t("lang.invoice_date"), sortable: false, align: "center", width: "15%" },
                { text: this.$t("lang.due_date"), sortable: false, align: "center", width: "15%" },
                { text: this.$t("lang.total_amount"), sortable: false, width: "15%" },
                { text: this.$t("lang.balance"), sortable: false, width: "10%" },
                { text: this.$t("lang.status"), sortable: false, align: "center", width: "10%" },
            ],
            enableAddModal: false,
            enableEditModal: false,
            customers: null,
            fe_invoice: {},
            filter: {
                search: "",
                status_id: "",
                company_id: "",
            },
            fe_invoice_dialog: false,
            dbGetFeInvoices: _.debounce(this.getFeInvoices, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchFeInvoices", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.fe_invoices) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.refresh();
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchFeInvoices({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.fe_invoices) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                this.refresh();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit("resetFeInvoices");
        this.$store.commit("resetOptions");
        next();
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.fe_invoices.fe_invoices_filter,
            page: (state) => state.fe_invoices.page,
            rules_fe_invoices: (state) => state.fe_invoices.rules_fe_invoices,
            fe_invoices: (state) => state.fe_invoices.fe_invoices,
            exchange_rates: (state) => state.exchange_rates.exchange_rates,
            fe_invoice_status: (state) => state.options_categories.fe_invoice_status,
            customer_options: (state) => state.customers.customer_options,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchFeInvoices", "saveFeInvoice", "deleteFeInvoice", "fetchExchangeRates", "fetchOptions", "fetchCustomers"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openFeInvoiceForm(item = null) {
            if (item != null) {
                this.$router.push({ name: "fe_invoice", params: { id: item.invoice_id } });
            } else {
                this.$router.push({ name: "fe_invoice" });
            }
        },
        saveFeInvoices() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_fe_invoice")) {
                    let body = this.prepForm(this.fe_invoice, this.rules_fe_invoices);

                    this.saveFeInvoice({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getFeInvoices();
                            } else {
                                this.$router.push({ name: "fe_invoice", params: { id: data.invoice_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteFeInvoices(id = null) {
            this.deleteFeInvoice({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getFeInvoices();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },
        getFeInvoices(pg_refresh = false) {
            this.startLoader();

            this.fetchFeInvoices({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.fe_invoice_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        setExchangeRate(exchange_rate_id) {
            // Get the exchange rate from the exchange rates list based on the exchange_rate_id and set quote request.exchange_rate
            let exchange_rate = this.exchange_rates.find((x) => x.exchange_rate_id == exchange_rate_id);
            this.order.exchange_rate = exchange_rate.rate;
        },
        async refresh(force = false) {
            this.startLoader();

            if (this.fe_invoice_status == 0 || force == true) await this.fetchOptions({ body: { slug: "fe_invoice_status", options: 1 } });
            //if (this.customer_options.length == 0 || force == true)

            this.finishLoader();
        },
    },
};
</script>
